import { render, staticRenderFns } from "./GasKineticTheoryViz.vue?vue&type=template&id=6fe85beb&scoped=true"
import script from "./GasKineticTheoryViz.vue?vue&type=script&lang=js"
export * from "./GasKineticTheoryViz.vue?vue&type=script&lang=js"
import style0 from "./GasKineticTheoryViz.vue?vue&type=style&index=0&id=6fe85beb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe85beb",
  null
  
)

export default component.exports